module.exports = __webpack_public_path__ + "cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cf.svg
// module id = 484
// module chunks = 0